import { render, staticRenderFns } from "./PazarForushgahi.vue?vue&type=template&id=fbeffe52"
import script from "./PazarForushgahi.vue?vue&type=script&lang=js"
export * from "./PazarForushgahi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports